import React from 'react';
import Main from './components/Main';
import './index.scss';

const NoWarehouse = () => {
    return (
        <div>
            <Main />
        </div>
    )
}
export default NoWarehouse
